class CardProduct extends HTMLElement {
  constructor() {
    super();
    this.modal = null;
  }

  connectedCallback() {
    this.modal = this.querySelector('card-product-modal');
  }

  openModal() {
    this.modal.open();
  }

  closeModal() {
    this.modal.close();
  }
}

customElements.define('card-product', CardProduct);

class CardProductModal extends HTMLElement {
  static observedAttributes = ['open'];

  constructor() {
    super();
    this._shadowRoot = this.attachShadow({ mode: 'open' });
    this._open = false;
    this._panel = null;
    this._overlay = null;
  }

  connectedCallback() {
    this._render();
    this._panel = this.shadowRoot.querySelector('.num-modal__panel');
    this._overlay = this.shadowRoot.querySelector('.num-modal__overlay');
    this._attachEventListeners();
  }

  attributeChangedCallback(name) {
    if (name === 'open') {
      this._open = this.hasAttribute('open');
      this._updateModalState();
    }
  }

  open() {
    this._open = true;
    this.setAttribute('open', '');
  }

  close() {
    this._open = false;
    this.removeAttribute('open');
  }

  toggle() {
    this._open ? this.close() : this.open();
  }

  _dispatchEvent(eventName) {
    this.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
  }

  _attachEventListeners() {
    this._overlay.addEventListener('click', this.close.bind(this));
  }

  _updateModalState() {
    this._open ? this._dispatchEvent('onOpen') : this._dispatchEvent('onClose');
  }

  _render() {
    this._shadowRoot.innerHTML = `
      <style>${this._getStyles()}</style>
      <div class="num-modal__overlay"></div>
      <div class="num-modal__panel">
        <slot></slot>
      </div>
    `;
  }

  _getStyles() {
    return `
        :host {
          display: block;
          position:absolute; 
          width:100%;
          bottom: 0;
          z-index: 100;
        }
        .num-modal__overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          visibility: hidden;
          opacity: 0;
          transition: visibility 0.3s, opacity 0.3s ease
        }
        .num-modal__panel {
          position: absolute;
          bottom: 10px;
          left: 50%;
          width: 90%;
          height: 150px;
          padding: 10px;
          background-color: white;
          visibility: hidden;
          opacity: 0;
          transform: translateX(-50%);
          transition: visibility 0.3s, opacity 0.3s ease;
        }
        
        :host([open]) .num-modal__overlay {
            visibility: visible;
            opacity: 1;
        }
        :host([open]) .num-modal__panel {
            visibility: visible;
            opacity: 1;
        }

        @media screen and (max-width: 1280px) {
          .num-modal__panel {
            position: absolute;
            bottom: 5px;
            width: calc(100% - 10px);
            padding: 10px 0 50px;
            background-color: white;
            height: auto;
          }
        }
    `;
  }
}

customElements.define('card-product-modal', CardProductModal);
